module.exports = __webpack_public_path__ + "img/blue-Return to Single View - Icon.4bc54b0d.jpg";